<template>
  <div id="RegisterDashboard_main">
    <table aria-describedby="attendance_table">
      <thead>
        <tr>
          <th>總戶數</th>
          <th>法定出席人數基準（{{ threshold(data.threshold) }}）</th>
          <th>實到人數</th>
          <th>已簽退人數</th>
          <th>{{ areaSum }}</th>
          <th>區分所有權佔比（{{ threshold(data.threshold) }}）</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="data-text">
              {{ data.tabletTotal }}
            </div>
            <div class="normal-text">
              戶
            </div>
          </td>
          <td>
            <div v-if="data.useTablet">
              <div class="data-text">
                {{ data.tabletThreshold }}
              </div>
              <div class="normal-text">
                人
              </div>
            </div>
            <div
              v-else
              class="notControl-text"
            >
              －
            </div>
          </td>
          <td>
            <div class="data-text">
              {{ data.tabletValue }}
            </div>
            <div class="normal-text">
              人
            </div>
          </td>
          <td>
            <div class="data-text">
              {{ data.unregisterValue }}
            </div>
            <div class="normal-text">
              人
            </div>
          </td>
          <td>
            <div v-if="data.useArea">
              <div class="data-text">
                {{ data.areaValue.toFixed(2) }}
              </div>
              <div class="normal-text">
                {{ unit }}
              </div>
            </div>
            <div
              v-else
              class="notControl-text"
            >
              －
            </div>
          </td>
          <td>
            <div v-if="data.useArea">
              <div class="data-text">
                {{ areaRatio }}
              </div>
              <div class="normal-text">
                ％
              </div>
            </div>
            <div
              v-else
              class="notControl-text"
            >
              －
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="tip">
      <span>依照社區規約之規定，區分所有權人會議應有</span>
      <div class="key-text">
        <span v-if="data.useTablet && data.useArea">區分所有權人及佔比達 {{ threshold(data.threshold) }}（{{ data.tabletThreshold }}戶 / {{ data.areaThreshold }} {{ unit }}）</span>
        <span v-else-if="data.useTablet">區分所有權人 {{ threshold(data.threshold) }}（{{ data.tabletThreshold }}戶）</span>
        <span v-else-if="data.useArea">區分所有權佔比達 {{ threshold(data.threshold) }}（{{ data.areaThreshold }} {{ unit }}）</span>
      </div>
      <span>以上出席時，由主席宣布會議正式開始暨確認會議程序及議題討論次序。</span>
    </div>
  </div>
</template>

<script>
import tw from '../utils'
export default {
  props: {
    data: Object
  },
  data () {
    const { areaSum, unit } = tw
    return {
      areaSum,
      unit
    }
  },
  computed: {
    areaRatio () {
      if (this.data) {
        // eslint-disable-next-line eqeqeq
        if (this.data.areaValue == 0 || this.data.areaTotal == 0) { return '0.00' } else {
          const areaRatio = (this.data.areaValue / this.data.areaTotal * 100).toFixed(2)
          // eslint-disable-next-line eqeqeq
          if (areaRatio == '0.00' && this.data.areaValue > 0) { return '＜0.01' } else { return areaRatio }
        }
      }
    }
  },
  mounted () {

  },
  methods: {
    threshold (attendanceThreshold) {
      if (attendanceThreshold) { return Math.ceil(this.data.threshold * 100) + '％' }
    }
  }
}
</script>

<style lang="sass" scoped>
#RegisterDashboard_main
  table
    border: 1px solid $borderDark4
    font-size: 16px
    width: 100%
    th
      border: 1px solid $borderDark4
      padding: 12px
      font-size: 15px
      font-weight: 600
    td
      border: 1px solid $borderDark4
      padding: 12px
      line-height: 40px
      .data-text
        display: inline-block
        color: $mainColor
        font-size: 28px
        font-weight: 600
        vertical-align: bottom
      .normal-text
        display: inline-block
        font-size: 19px
        line-height: 40px
        margin-left: 8px
        vertical-align: bottom
        color: $subFontColor
      .notControl-text
        color: $grayFontColor
        font-size: 17px
        font-weight: 600
  .tip
    margin-top: 12px
    font-size: 17px
    line-height: 24px
    color: $subFontColor
    .key-text
      font-weight: 600
      font-size: 19px
      margin: 8px 0
      color: $mainFontColor
</style>
